function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M0 39h113v8H0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M.5 39.5h112v7H.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M4 46h104v94H4z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M4.5 46.5h103v93H4.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M11 53h90v75H11z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M11.5 53.5h89v74h-89z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M89 128h-7.901V95.82c0-2.944-2.353-3.172-3.075-3.172s-3.073.228-3.073 3.172c0 7.587-5.676 11.68-11.016 11.68C58.502 107.5 53 103.488 53 95.82V85h7.901v10.82c0 3.558 2.322 3.834 3.034 3.834 1.505 0 3.114-1.007 3.114-3.834 0-7.157 5.655-11.019 10.975-11.019 5.321 0 10.976 3.862 10.976 11.02V128z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M88.5 127.5V95.82c0-6.269-4.75-10.519-10.476-10.519-5.725 0-10.475 4.25-10.475 10.52 0 2.779-1.516 4.333-3.614 4.333-1.945 0-3.534-1.22-3.534-4.334V85.5H53.5v10.32c0 6.767 4.623 11.18 10.435 11.18 5.742 0 10.516-4.51 10.516-11.18 0-2.659 1.617-3.672 3.573-3.672 1.957 0 3.575 1.013 3.575 3.672v31.68H88.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M11 52.964L41.05 49v82.928L11 127.964z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M11.5 53.402v74.123l29.05 3.832V49.57L11.5 53.402z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M100 52.964l21-6.555v88.105l-21-6.55z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M100.5 53.332v74.264l20 6.238V47.09l-20 6.243z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M16 58.321L36 56v69.643l-20-2.322z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M16.5 58.767v64.109l19 2.205v-68.52l-19 2.206z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M21.5 34h70a4.5 4.5 0 014.5 4.5V40H17v-1.5a4.5 4.5 0 014.5-4.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M17.5 39.5h78v-1a4 4 0 00-4-4h-70a4 4 0 00-4 4v1z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M77.013 11.179H70.99A5.5 5.5 0 0060 11.5V35h-6V10.72C54 4.921 58.701.22 64.5.22h2.013c5.799 0 10.5 4.701 10.5 10.5v.459z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M76.513 10.679C76.49 5.175 72.022.72 66.513.72H64.5c-5.523 0-10 4.478-10 10V34.5h5v-23a6 6 0 0111.944-.821h5.069z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M74.5 20c1.667-.796 2.5-1.685 2.5-2.667 0-.982-.833-2.76-2.5-5.333-1.667 2.574-2.5 4.351-2.5 5.333 0 .982.833 1.871 2.5 2.667z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M74.5 19.443c1.363-.69 2-1.403 2-2.11 0-.773-.666-2.264-2-4.401-1.334 2.137-2 3.628-2 4.401 0 .707.637 1.42 2 2.11z"
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 10,
  height: 4,
  x: 69,
  y: 10,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 9,
  height: 3,
  x: 69.5,
  y: 10.5,
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M68 26h3v9h-3z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M68.5 26.5h2v8h-2z"
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 14,
  height: 5,
  x: 65,
  y: 24,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 13,
  height: 4,
  x: 65.5,
  y: 24.5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M43 26h3v9h-3z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M43.5 26.5h2v8h-2z"
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 14,
  height: 5,
  x: 35,
  y: 24,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 13,
  height: 4,
  x: 35.5,
  y: 24.5,
  rx: 2
}));

function SvgRoomSinkKitchen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 140,
    viewBox: "0 0 121 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSinkKitchen);
export default __webpack_public_path__ + "static/media/RoomSinkKitchen.f86b8c4a.svg";
export { ForwardRef as ReactComponent };